var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{directives:[{name:"touch",rawName:"v-touch:tap.prevent",value:(
      function () {
        _vm.$emit('etablissement-click', _vm.etablissement);
      }
    ),expression:"\n      () => {\n        $emit('etablissement-click', etablissement);\n      }\n    ",arg:"tap",modifiers:{"prevent":true}}],staticClass:"logo-etablissement",attrs:{"alt":"etabs","src":_vm.etablissement.getLogoetablissement_data()}}),_c('label',{staticClass:"labetab",attrs:{"for":"etabs"}},[_vm._v(" "+_vm._s(_vm.etablissement.nom)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }